import { render, staticRenderFns } from "./PatientDashboard.vue?vue&type=template&id=419da158&scoped=true&lang=pug"
import script from "./PatientDashboard.vue?vue&type=script&lang=js"
export * from "./PatientDashboard.vue?vue&type=script&lang=js"
import style0 from "./PatientDashboard.vue?vue&type=style&index=0&id=419da158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419da158",
  null
  
)

export default component.exports